import firebase from '../../lib/firebase.prod';
import HelloSign from 'hellosign-embedded';
import * as PROJECT_CODE from '../../constants/projectCode';
import {
	SaveClientSignatureRequestInfo,
	SaveClientSignatureRequestInfoExtras,
} from '../../components/document/SaveAndLoadDocument';
import dayjs, { extend } from 'dayjs';
import * as ALL_DOCUMENTS from '../../constants/helloSignDocumentInfo';
import * as CLIENT_ID from '../../constants/helloSignClientId';

// @desc    get document by info extra
export async function GetDocumentByInfoExtras(
	expandedClient,
	client,
	documentInfo,
	authToken,
	adminEmail,
	theseCustomFields,
	theseCustomSigners,
	useSecondPurchaser
) {
	if (theseCustomFields === null || theseCustomFields === undefined) {
		theseCustomFields = [];
	}

	console.log('clientttttttafaf', client);

	//console.log("Client Json " + JSON.stringify(client));

	const helloClient = new HelloSign();
	var getDoc = firebase.functions().httpsCallable('HelloSignCallDocument');

	console.log('Current auth token ' + authToken);

	var jsonInfo = {
		authToken: authToken,
		senderEmail: adminEmail,
		subjectName: documentInfo.subjectName,
		message: documentInfo.message,
		projectCode: PROJECT_CODE.projectCode,
		templateId: documentInfo.templateId,
		clientEmail: client.clientEmail,
		clienFullName: client.fullName,
		customFields: theseCustomFields,
	};

	console.log('jason info getClient doc form', theseCustomSigners);

	if (theseCustomSigners !== undefined) {
		console.log(
			' GetDocumentByInfoExtras CUSTOM SIGNERS ',
			theseCustomSigners
		);
		jsonInfo['newSigners'] = theseCustomSigners;
		jsonInfo['overideSigners'] = true;
		jsonInfo['overideMetaData'] = true;
		jsonInfo['newMetaData'] = { my_client: client.clientEmail };
	}

	if (useSecondPurchaser === true) {
		if (documentInfo.secondPurchaserTemplateId !== undefined) {
			jsonInfo['templateId'] = documentInfo.secondPurchaserTemplateId;
			jsonInfo['secondClientEmail'] =
				client.documentInformation.document.individualSecondPurchaserDetails?.email;
			jsonInfo['secondClientFullName'] =
				client.documentInformation.document
					.individualSecondPurchaserDetails?.firstName +
				' ' +
				client.documentInformation.document
					.individualSecondPurchaserDetails?.lastName;
			getDoc = firebase
				.functions()
				.httpsCallable('HelloSignCallDocumentSecondPurchaser');

			//secondClientFullName
			//jsonInfo['secondClientEmail'] = client.documentInformation.document.
		}
	}

	var finishedData;

	const displayHelloDoc = (signUrl) => {
		console.log('signurl: ' + signUrl);
		helloClient.open(signUrl, {
			skipDomainVerification: true,
			clientId: CLIENT_ID.clientId,
		});
	};

	helloClient.on('finish', () => {
		SaveClientSignatureRequestInfoExtras(
			firebase,
			finishedData,
			client.clientEmail,
			documentInfo.subjectName,
			client.clientCreatorId
		);
	});

	getDoc(jsonInfo)
		.then((result) => {
			//setLoading(false);
			console.log(
				'doc result: ' + JSON.stringify(result['data']['claim_url'])
			);
			displayHelloDoc(result['data']['claim_url']);

			// SaveClientSignatureRequestInfoExtras(
			// 	firebase,
			// 	result['data'],
			// 	client.clientEmail,
			// 	documentInfo.subjectName
			// );
			finishedData = result['data'];
		})
		.catch(function (error) {
			console.log('Error ' + error);
		});
}

export async function GetDocumentByInfoAPS(
	client,
	documentInfo,
	authToken,
	adminEmail,
	buildingPriceWord,
	buildingPrice,
	elevationId,
	clientPostalCode,
	clientAddress,
	buildingName,
	secondIndividual,
	optionSelected,
	setLoading,
	clientCreatorId,
	individualDetails,
	corporationDetails,
	firstInstallmentCost,
	secondInstallmentCost,
	thirdInstallmentCost,
	forthInstallmentCost,
	fifthInstallmentCost,
	sixthInstallmentCost,
	buildingModel
) {
	console.log(
		'individualDetailsindividualDetailsindividualDetails',
		individualDetails
	);

	const helloClient = new HelloSign();
	var getDoc = firebase.functions().httpsCallable('HelloSignCallDocument');

	console.log('Current auth token ', authToken);
	var apsClientSignatureDate = new Date();
	var apsBuilderSignatureDate = new Date();
	var currentDate = new Date();

	var allMonths = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];

	var dateOfBirthNoTime = new dayjs(
		client?.documentInformation.document.individualDetails.dob
	).format('DD/MM/YYYY');

	var convertedPrice = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(buildingPrice);

	var closing_date = client?.documentInformation.document.closingDate;

	var test_date = dayjs(closing_date);
	console.log(
		'Closing unix ' + test_date + ' unix ' + dayjs(test_date).unix()
	);

	var closing_date_hours_extra = dayjs(closing_date).unix() * 1000 + (360000 * 12);//counteract daylight saving s***
	var second_closing_date = closing_date_hours_extra + 86400000 * 120;; //.add(120, 'days');//Original Closing Date + 120 days:
	var firm_closing_date = closing_date_hours_extra + 86400000 * 240; //.add(240, 'days');//Original Closing Date + 240 Days:
	var outside_closing_date = closing_date_hours_extra + 86400000 * 485; //.add(485, 'days');//Original Closing Date + 120 days  + 365 days:
	var notice_delay = closing_date_hours_extra + 86400000 * -90; //.add(-90, 'days');// Original Closing Date - 90 days:
	var notice_second_delay = closing_date_hours_extra + 86400000 * 30; //.add(30, 'days');// Original Closing Date + 30 days
	var termination_date = closing_date_hours_extra + 86400000 * 635; //.add(635, 'days');// Original Closing date + 240 + 365 + 30:

	console.log('FOUND OPTION SELECTED ', optionSelected);
	console.log('secondInstallmentCost ', secondInstallmentCost);
	var secondInstallDollar = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(secondInstallmentCost);

	var thirdInstallDollar = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(thirdInstallmentCost);

	var forthInstallDollar = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(forthInstallmentCost);

	var fifthInstallDollar = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(fifthInstallmentCost);

	var sixthInstallDollar = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(sixthInstallmentCost);
	console.log('Building Name {' + buildingName + '}');
	console.log(' Template id ', documentInfo.buildingTemplateId);
	var jsonInfo = {
		authToken: authToken,
		senderEmail: adminEmail,
		subjectName: documentInfo.subjectName,
		message: documentInfo.message,
		projectCode: PROJECT_CODE.projectCode,
		templateId: documentInfo.buildingTemplateId[buildingName],
		clientEmail: client.clientEmail,
		clienFullName:
			individualDetails && individualDetails !== ''
				? individualDetails.firstName + ' ' + individualDetails.lastName
				: corporationDetails?.corporationName,
		customFields: [
			{
				name: 'buyer_full_name',
				value:
					individualDetails && individualDetails !== ''
						? individualDetails.firstName +
						  ' ' +
						  individualDetails.lastName
						: corporationDetails?.corporationName,
			},
			{
				name: 'building_lot_number',
				value: client.documentInformation.document.lotList[0]
					.buildingLot,
			},
			{
				name: 'block_number',
				value: client.documentInformation.document.lotList[0].block,
			},
			{
				name: 'model_option',
				value: optionSelected.join(', '),
			},
			{
				name: 'closing_date',
				value: dayjs(closing_date).format('DD/MM/YYYY'),
			},
			{
				name: 'display_price_word',
				value: buildingPriceWord,
			},
			{
				name: 'buyer_dob',
				value: dateOfBirthNoTime,
			},
			{
				name: 'display_price_number',
				value: convertedPrice,
			},
			{
				name: 'client_address',
				value: clientAddress,
			},
			{
				name: 'client_email',
				value: client.clientEmail,
			},
			{
				name: 'client_phone',
				value: client.phoneNumber,
			},
			{
				name: 'building_elevation',
				value: elevationId,
			},
			{
				name: 'postal_code',
				value: clientPostalCode,
			},
			{
				name: 'second_install',
				value: secondInstallDollar,
			},
			{
				name: 'third_install',
				value: thirdInstallDollar,
			},
			{
				name: 'fourth_install',
				value: forthInstallDollar,
			},
			{
				name: 'fifth_install',
				value: fifthInstallDollar,
			},
			{
				name: 'building_model_number',
				value: buildingModel,
			},
			{
				name: 'second_closing_date',
				value: dayjs(second_closing_date).format('DD/MM/YYYY'),
			},
			{
				name: 'firm_closing_date',
				value: dayjs(firm_closing_date).format('DD/MM/YYYY'),
			},
			{
				name: 'outside_closing_date',
				value: dayjs(outside_closing_date).format('DD/MM/YYYY'),
			},
			{
				name: 'notice_delay',
				value: dayjs(notice_delay).format('DD/MM/YYYY'),
			},
			{
				name: 'notice_second_delay',
				value: dayjs(notice_second_delay).format('DD/MM/YYYY'),
			},
			{
				name: 'termination_date',
				value: dayjs(termination_date).format('DD/MM/YYYY'),
			}
		],
	};

	// {
	// 	name: 'second_closing_date',
	// 	value: dayjs(second_closing_date).format('DD/MM/YYYY'),
	// },
	// {
	// 	name: 'firm_closing_date',
	// 	value: dayjs(firm_closing_date).format('DD/MM/YYYY'),
	// },
	// {
	// 	name: 'outside_closing_date',
	// 	value: dayjs(outside_closing_date).format('DD/MM/YYYY'),
	// },
	// {
	// 	name: 'notice_delay',
	// 	value: dayjs(notice_delay).format('DD/MM/YYYY'),
	// },
	// {
	// 	name: 'notice_second_delay',
	// 	value: dayjs(notice_second_delay).format('DD/MM/YYYY'),
	// },
	// {
	// 	name: 'termination_date',
	// 	value: dayjs(termination_date).format('DD/MM/YYYY'),
	// },

	if (
		secondIndividual?.firstName &&
		secondIndividual?.lastName &&
		secondIndividual?.email
	) {
		jsonInfo['secondClientFullName'] =
			secondIndividual.firstName + ' ' + secondIndividual.lastName;
		jsonInfo['secondClientEmail'] = secondIndividual.email;
		jsonInfo['templateId'] =
			documentInfo.secondPurchaserTemplateId[buildingName];
		getDoc = firebase
			.functions()
			.httpsCallable('HelloSignCallDocumentSecondPurchaser');

		var secondDOB = new dayjs(secondIndividual.dob).format('DD/MM/YYYY');

		var secondfDobJson = {
			name: 'second_dob',
			value: secondDOB,
		};

		var secondfFullNameJson = {
			name: 'second_full_name',
			value: secondIndividual.firstName + ' ' + secondIndividual.lastName,
		};

		jsonInfo.customFields.push(secondfDobJson);
		jsonInfo.customFields.push(secondfFullNameJson);
	}

	const displayHelloDoc = (signUrl) => {
		console.log('signurl: ' + signUrl);
		helloClient.open(signUrl, {
			skipDomainVerification: true,
			clientId: CLIENT_ID.clientId,
		});
	};

	var finishedData;

	console.log('GetDocumentByInfoAPS line 268');

	helloClient.on('finish', async () => {
		await SaveClientSignatureRequestInfo(
			firebase,
			finishedData,
			client.clientEmail,
			ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo.subjectName,
			clientCreatorId
		);

		var clientRef = await firebase
			.database()
			.ref(
				'/kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/salesAgents/' +
					client.salesAgentPointer +
					'/myClients/' +
					client.keyValue +
					'/documentInformation'
			);

		clientRef
			.update({
				documentStatus: 'sent',
			})
			.then(() => (window.location.pathname = '/clients'));

		console.log('helloClient on finish line 285');

		// window.location.pathname = '/clients';
	});

	helloClient.on('close', () => {
		setLoading(false);
	});

	helloClient.on('ready', () => {
		setLoading(false);
		var clientRef = firebase
			.database()
			.ref(
				'/kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/salesAgents/' +
					client.salesAgentPointer +
					'/myClients/' +
					client.keyValue +
					'/documentInformation'
			);

		clientRef.update({
			documentStatus: 'ready',
		});
	});
	getDoc(jsonInfo)
		.then((result) => {
			console.log(
				'doc result: ' + JSON.stringify(result['data']['claim_url'])
			);
			displayHelloDoc(result['data']['claim_url']);
			finishedData = result['data'];
			// SaveClientSignatureRequestInfo(
			// 	firebase,
			// 	result['data'],
			// 	client.clientEmail,
			// 	ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo.subjectName
			// );
		})
		.catch(function (error) {
			console.log('Error ' + error);
		});
}

export async function GetDocumentByInfoCondoDoc(
	firebase,
	expandedClient,
	client,
	documentInfo,
	authToken,
	adminEmail,
	secondIndividual
) {
	//console.log("Client Json " + JSON.stringify(client));

	const helloClient = new HelloSign();
	var getDoc = firebase.functions().httpsCallable('HelloSignCallDocument');

	console.log('Current auth token ' + authToken);
	var apsClientSignatureDate = new Date();
	var apsBuilderSignatureDate = new Date();
	var currentDate = new Date();

	//get the aps builder signature date

	var objBuilder = client.documentInformation.signatureRequests;

	console.log('Condo doc get document by info', objBuilder);

	var signatureRequestsKeys = Object.keys(objBuilder);

	console.log(
		'Condo doc get document by signatureRequestsKeys',
		signatureRequestsKeys
	);

	var eventTime;
	var timeFound;
	var signatureObj;
	var builderArr = [];
	var signatureObjBuilder;
	var eventTimeObj;

	console.log('objBuilder ', objBuilder);

	signatureRequestsKeys?.forEach((key) => {
		var signatureUpdatesObj = objBuilder[key]?.signatureUpdates;

		console.log('signatureUpdatesObj ', signatureUpdatesObj);

		var signatureUpdatesKeys =
			signatureUpdatesObj && Object.keys(signatureUpdatesObj);

		console.log('signatureUpdatesKeys ', signatureUpdatesKeys);

		console.log('signatureRequestsKeys ', signatureUpdatesKeys);

		signatureUpdatesKeys &&
			signatureUpdatesKeys?.forEach((key) => {
				signatureObj =
					signatureUpdatesObj[key].signature_request.signatures;
				eventTime = signatureUpdatesObj[key].event.event_time;

				eventTimeObj = {
					eventTime: eventTime,
				};

				builderArr.push(eventTimeObj);

				var signatureObjKey = Object.keys(signatureObj);

				console.log('signatureObjKey ', signatureObjKey);

				signatureObjKey.forEach((key) => {
					var signerRole = signatureObj[key].signer_role;
					var statusCode = signatureObj[key].status_code;

					if (signerRole === 'Builder' && timeFound === false) {
						console.log('GetDocumentByInfoCondoDockmk 458');
						signatureObjBuilder = {
							signerRole: signerRole,
							statusCode: statusCode,
						};

						if (statusCode === 'signed') {
							console.log('GetDocumentByInfoCondoDockmk 465');
							timeFound = true;
							apsBuilderSignatureDate = dayjs(
								parseInt(builderArr[0].eventTime) * 1000
							).format('DD MMMM YYYY HH:mm');
						}
						builderArr.push(signatureObjBuilder);
					}
				});
			});
	});

	console.log('apsBuilderSignatureDate: ', apsBuilderSignatureDate);

	var clientArr = [];
	var clientTimeFound;
	var eventTimeClientObj;
	var signatureObjBuilderForClient;
	var signatureObjForClient;
	var eventTimeForClient;

	console.log(
		'Condo doc this is for the signatureRequestsKeys 499',
		signatureRequestsKeys
	);

	signatureRequestsKeys &&
		signatureRequestsKeys.forEach((key) => {
			var signatureUpdatesObj = objBuilder[key].signatureUpdates;

			console.log(
				'Condo doc this is for the signatureUpdatesObj 508',
				signatureUpdatesObj
			);

			var signatureUpdatesKeys =
				signatureUpdatesObj && Object.keys(signatureUpdatesObj);

			console.log('signatureRequestsKeys 515', signatureUpdatesKeys);

			signatureUpdatesKeys &&
				signatureUpdatesKeys.forEach((key) => {
					signatureObjForClient =
						signatureUpdatesObj[key].signature_request.signatures;
					eventTimeForClient =
						signatureUpdatesObj[key].event.event_time;

					eventTimeClientObj = {
						eventTime: eventTimeForClient,
					};

					clientArr.push(eventTimeClientObj);

					var signatureObjKey = Object.keys(signatureObjForClient);

					console.log('signatureObjKey 532', signatureObjKey);

					signatureObjKey.forEach((key) => {
						var signerRole = signatureObjForClient[key].signer_role;
						var statusCode = signatureObjForClient[key].status_code;

						console.log('signerRole 538', signerRole, statusCode);
						if (
							signerRole === 'Client' &&
							clientTimeFound === false
						) {
							signatureObjBuilderForClient = {
								signerRole: signerRole,
								statusCode: statusCode,
							};

							if (statusCode === 'signed') {
								clientTimeFound = true;
								apsClientSignatureDate = dayjs(
									parseInt(clientArr[0].eventTime) * 1000
								).format('DD MMMM YYYY HH:mm');
								console.log(
									'Aps Client Sig Found time 554',
									apsClientSignatureDate
								);
							}
							clientArr.push(signatureObjBuilderForClient);
						}
					});
				});
		});

	console.log('apsClientSignatureDate: 564 ', apsClientSignatureDate);

	var allMonths = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];
	console.log(
		apsClientSignatureDate +
			' aps day month ' +
			allMonths[apsClientSignatureDate.getMonth()] +
			' | ' +
			apsClientSignatureDate.getDate() +
			' unix '
	);

	console.log('This is the condo docs client fullName 589', client.fullName);
	console.log('This is the condo docs client 590', client);

	console.log(
		'THis is the jsonInfo in condo docs test',
		client.fullName,
		client.documentInformation.document.lotList[0].buildingLot,
		allMonths[apsClientSignatureDate.getMonth()] +
			' ' +
			apsClientSignatureDate.getDate(),
		apsClientSignatureDate.getFullYear(),
		allMonths[apsBuilderSignatureDate.getMonth()] +
			' ' +
			apsBuilderSignatureDate.getDate(),
		apsBuilderSignatureDate.getFullYear(),
		currentDate.getFullYear(),
		allMonths[currentDate.getMonth()],
		currentDate.getDate()
	);

	var jsonInfo = {
		authToken: authToken,
		senderEmail: adminEmail,
		subjectName: documentInfo.subjectName,
		message: documentInfo.message,
		projectCode: PROJECT_CODE.projectCode,
		templateId: documentInfo.templateId,
		clientEmail: client.clientEmail,
		clienFullName: client.documentInformation.document.individualDetails
			? client.documentInformation.document.individualDetails.firstName +
			  ' ' +
			  client.documentInformation.document.individualDetails.lastName
			: client.documentInformation.document.corporationDetails
					.corporationName,
		customFields: [
			{
				name: 'buyer_full_name',
				value: client.documentInformation.document.individualDetails
					? client.documentInformation.document.individualDetails
							.firstName +
					  ' ' +
					  client.documentInformation.document.individualDetails
							.lastName
					: client.documentInformation.document.corporationDetails
							.corporationName,
			},
			{
				name: 'building_lot_number',
				value: client.documentInformation.document.lotList[0]
					.buildingLot,
			},
			{
				name: 'buyer_day_month',
				value:
					allMonths[apsClientSignatureDate.getMonth()] +
					' ' +
					apsClientSignatureDate.getDate(),
			},
			{
				name: 'buyer_year',
				value: apsClientSignatureDate.getFullYear(),
			},
			{
				name: 'builder_day_month',
				value:
					allMonths[apsBuilderSignatureDate.getMonth()] +
					' ' +
					apsBuilderSignatureDate.getDate(),
			},
			{
				name: 'builder_year',
				value: apsBuilderSignatureDate.getFullYear(),
			},
			{
				name: 'this_year',
				value: currentDate.getFullYear(),
			},
			{
				name: 'this_month',
				value: allMonths[currentDate.getMonth()],
			},
			{
				name: 'today',
				value: currentDate.getDate(),
			},
		],
	};

	if (
		secondIndividual?.firstName &&
		secondIndividual?.lastName &&
		secondIndividual?.email
	) {
		console.log(
			'GetDocumentByInfoCondoDockmk 620',
			secondIndividual.firstName,
			secondIndividual.lastName
		);

		jsonInfo['secondClientFullName'] =
			secondIndividual.firstName + ' ' + secondIndividual.lastName;
		jsonInfo['secondClientEmail'] = secondIndividual.email;
		jsonInfo['templateId'] = documentInfo.secondPurchaserTemplateId;
		getDoc = firebase
			.functions()
			.httpsCallable('HelloSignCallDocumentSecondPurchaser');

		var secondfFullNameJson = {
			name: 'second_full_name',
			value: secondIndividual.firstName + ' ' + secondIndividual.lastName,
		};

		jsonInfo.customFields.push(secondfFullNameJson);

		console.log('getDoc aaisi 632', getDoc);

		console.log('GetDocumentByInfoCondoDockmk 632', jsonInfo);
	}

	const displayHelloDoc = (signUrl) => {
		console.log('signurl: ', signUrl);
		helloClient.open(signUrl, {
			skipDomainVerification: true,
			clientId: CLIENT_ID.clientId,
		});
	};

	var finishedData;

	helloClient.on('finish', () => {
		var clientRef = firebase
			.database()
			.ref(
				'/kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/salesAgents/' +
					client.salesAgentPointer +
					'/myClients/' +
					client.keyValue +
					'/documentInformation'
			);

		clientRef.update({
			documentCondoStatus: 'sent',
		});

		console.log('hello client on finish');

		SaveClientSignatureRequestInfo(
			firebase,
			finishedData,
			client.clientEmail,
			ALL_DOCUMENTS.allDocumentTypeInfo.condoDocFirebaseInfo.subjectName
		);
	});

	getDoc(jsonInfo)
		.then((result) => {
			//setLoading(false);
			console.log('doc resultrss: ', result);
			console.log('doc result: ', result['data']['claim_url']);
			displayHelloDoc(result['data']['claim_url']);

			finishedData = result['data'];
			// SaveClientSignatureRequestInfo(
			// 	firebase,
			// 	result['data'],
			// 	client.clientEmail,
			// 	ALL_DOCUMENTS.allDocumentTypeInfo.condoDocFirebaseInfo.subjectName
			// );
		})
		.catch(function (error) {
			console.log('Error ' + error);
		});
}
